var logger = {exports: {}};

export { logger as l };
